<template>
    <div>

      <UpdateProfileForm />
      <HistoryComponent/>
      <!-- Other profile components can be added here -->
    </div>
  </template>
  
  <script>
  import UpdateProfileForm from '../components/UpdateProfileForm.vue';

  
  export default {
    components: {
      UpdateProfileForm
    }
  }
  </script>
  